import { render } from "./BaseCard.vue?vue&type=template&id=2b224f88&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=2b224f88&scoped=true&lang=css"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b224f88"]])

export default __exports__